<div class="dx-card wide-card">
    <h4 class="content-block ap-green">O2 Global ASU Awards</h4>
    <h6 class="content-block">Total Number of LASUs: {{totalResultRowCount}}</h6>
    <dx-data-grid class="fixGridHeight" id="O2PortalGlobalASUAwardsGrid" [dataSource]="o2PortalGlobalASUAwardsData"  
    [showRowLines]="true" [showColumnLines]="true" [showBorders]="true" [allowColumnResizing]="false" [columnAutoWidth]="true"
    [rowAlternationEnabled]="true" (onContentReady)="onContentReady($event)">
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
                </dx-button>
                <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
                (onClick)="exportExcel($event)" [disabled]="isExportButtonDisabled">
                </dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>

        <dxi-column dataField="siteId" [visible]="false"></dxi-column>
        <dxi-column dataField="lasuregions" caption="LASU Regions" [width]="90"></dxi-column>
        <dxi-column dataField="countryName" caption="Country" [width]="90"></dxi-column>
        <dxi-column dataField="province" caption="State/Province" [width]="90"></dxi-column>
        <dxi-column dataField="city" caption="City" [width]="90"></dxi-column>
        <dxi-column dataField="unitOwner" caption="Owner" [width]="150"></dxi-column>
        <dxi-column dataField="customer" caption="Customer" [width]="150"></dxi-column>
        <dxi-column dataField="technologyProvider" caption="Technology Provider" [width]="100"></dxi-column>
        <dxi-column dataField="status" caption="Status" [width]="100"></dxi-column>
        <dxi-column dataField="onstreamYear" caption="Onstream Year"></dxi-column>
        <dxi-column dataField="awardYear" caption="Award Year"></dxi-column>
        <dxi-column dataField="gaseousOxygen" caption="GOX (MTD)" [width]="80"></dxi-column>
        <dxi-column dataField="gaseousNitrogen" caption="GAN (MTD)" [width]="80"></dxi-column>
        <dxi-column dataField="liquidOxygen" caption="LOX (TPD)" [width]="80"></dxi-column>
        <dxi-column dataField="liquidNitrogen" caption="LIN (TPD)" [width]="80"></dxi-column>
        <dxi-column dataField="liquidArgon" caption="LAR (TPD)" [width]="80"></dxi-column>
        <dxi-column dataField="endUseApplication" caption="End Use Application" [width]="90"></dxi-column>
        <dxi-column dataField="businessModel" caption="Business Model" [width]="100"></dxi-column>
        <dxi-column dataField="supplyMode" caption="Supply Mode" [width]="90"></dxi-column>
        <dxi-column dataField="notes" caption="Notes" [width]="200"></dxi-column>
        <dxi-column dataField="segmentShort" caption="Segment" [width]="90"></dxi-column>
        <dxi-column dataField="application" caption="Application" [width]="90"></dxi-column>
        <dxi-column dataField="oxygenApplication" caption="Oxygen Application" [width]="90"></dxi-column>
        <dxi-column dataField="operationalStatus" caption="Operational Status" [width]="90"></dxi-column>
        <dxi-column dataField="piggybackvsNonPiggyback" caption="Piggyback vs Non Piggyback" [width]="90"></dxi-column>
        <dxi-column dataField="avgTrainSize" caption="Avg Train Size" [width]="80"></dxi-column>
        <dxi-column dataField="trainClass" caption="Train Class" [width]="90"></dxi-column>
        <dxi-column dataField="o2sizeBrackets" caption="O2Size Brackets" [width]="80"></dxi-column>
        <dxi-column dataField="totalOxygen" caption="Total Oxygen" [width]="80"></dxi-column>
        <dxi-column dataField="totalNitrogen" caption="Total Nitrogen" [width]="80"></dxi-column>
        <dxi-column dataField="asunominalCapacity" caption="ASUNominal Capacity" [width]="80"></dxi-column>
        <dxi-column dataField="costEstimateMmusd" caption="Cost Estimate MMUSD" [width]="90"></dxi-column>
        <dxi-column dataField="acquisitionOpportunity" caption="Acquisition Opportunity" [width]="90"></dxi-column>
        <dxi-column dataField="replacementOpportunity" caption="Replacement Opportunity" [width]="90"></dxi-column>
        <dxi-column dataField="ageofASU" caption="Age Of ASU" [width]="90"></dxi-column>
        <dxi-column dataField="soetoSogconversionYear" caption="SOE to SOG Conversion Year" [width]="90"></dxi-column>
        <dxi-column dataField="manufacturer" caption="Manufacturer" [width]="90"></dxi-column>
        <dxi-column dataField="engineeringProvider" caption="Engineering Provide" [width]="90"></dxi-column>
        <dxi-column dataField="supplierIndustrialGases" caption="Supplier Industrial Gases" [width]="90"></dxi-column>
        <dxi-column dataField="didAPBid" caption="Did APBid" [width]="90"></dxi-column>
        <dxi-column dataField="announcementTitle" caption="Announcement Title" [width]="90"></dxi-column>
        <dxi-column dataField="announceDate" dataType="date" format="shortDate" caption="Announce Date" [width]="90"></dxi-column>
        <dxi-column dataField="productionFacilityID" caption="Facility ID" width="100"></dxi-column>
    </dx-data-grid>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="false" [closeOnOutsideClick]="false">
</dx-load-panel>
</div>
